// 地图
import map from '../../components/main-map/store.js';

export default map;
